<template>
  <div class="d-flex flex-column align-stretch available-data">
    <div class="available-table">
      <div v-if="loading" class="loader">
        <ellipsis-loader></ellipsis-loader>
        <div>Loading available drivers...</div>
      </div>
      <table v-if="!loading && drivers.length">
        <thead>
          <th></th>
          <th>ID</th>
          <th>NAME</th>
          <th>SECTOR</th>
          <th>SHIFT<br/>START</th>
          <th>SHIFT<br/>END</th>
        </thead>
        <tbody>
          <tr v-for="(driver, x) in drivers" :key="x">
            <td class="radio">
              <input type="radio" v-model="selectedDriver" :value="driver.id" />
            </td>
            <td class="id"><a :href="`#/provider/${driver.id}`" target="_blank">{{driver.id}}</a></td>
            <td class="name">{{driver.name}}</td>
            <td class="sector">{{driver.homeSector}}</td>
            <td class="shift">{{driver.availableFrom}}</td>
            <td class="shift">{{driver.availableUntil}}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!loading && !drivers.length" class="empty-state">
        No drivers found.
      </div>
    </div>
    <div>
      <driver-controls :tabIndex="currentDispatchTab" table="rsvpAvailableDrivers"></driver-controls>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import DriverControls from './DriverControls'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'

export default {
  name: 'rsvp-available-drivers',
  components: { DriverControls, EllipsisLoader },
  data () {
    return {
    }
  },
  computed: {
    dispatch () { return this.$store.state.dispatch },
    drivers () { return this.dispatch.availableDrivers.list },
    currentDispatchTab () { return this.dispatch.currentTable },
    loading () { return this.dispatch.availableDrivers.loading },
    selectedDriver: {
      get () { return this.dispatch.availableDrivers.selected },
      set (value) {
        this.$store.commit('dispatch/setAvailableDriversData', {selected: value})
      }
    },
  },
  methods: {
  },
  watch: {
  }
}
</script>


<style lang="scss" scoped>
.filter-available-drivers{
  .available-data{
    height: calc(100% - 50px);
  }
}
.available-table{
  height: 100%;
}
table{
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 100%;
  display: table-footer-group;
  text-align: center;

  thead{
    width: 100%;
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0, .3);

    th{
      padding: 5px;
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 2;
      background-color: #f5f5f5;
      text-transform: uppercase;
    }
  }
  tbody{
    font-size: 13px;
    line-height: 1.4;

    &::after{
      content: '-----------------------------------------------------------------------------------';
      max-height: 0;
      overflow: hidden;
      display: block;
      word-break: break-all;
    }
    tr{
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    }
    td{
      padding: 10px 5px;
      background: #fff;
    }
    a{
      font-weight: 600;
    }
  }
  .radio{
    width: 40px;
    padding: 10px;

    input{
      margin: 0;
      cursor: pointer;
    }
  }
  .id{
    width: 60px;
  }
  .name{
    width: 130px;
  }
  .sector{
    width: 150px;
  }
  .shift{
    width: 100px;
  }
}

.loader{
  text-align: center;
  padding: 50px 0;
  color: #a2b1b8;
  font-size: 14px;
  font-weight: 600;

  div{
    margin-top: 10px;
  }
}
.empty-state{
  font-weight: 700;
  padding: 40px;
  font-size: 16px;
  color: #777;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Dispatch/RsvpAvailableDrivers.vue